module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460955.18897085.png";